import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { DynamicFormItem } from '@ispm/shared/dynamic-form/classes/dynamic-form-item.class';
import { ITEMS_TYPES } from "@ispm/shared/dynamic-form/constants/ItemsTypes";

const FORM_KEY_EVENT_TYPE_SELECTION = 'EVENT_TYPE';

@Component({
  selector: 'ispm-timeline-event-filter',
  templateUrl: './timeline-event-filter.component.html',
  styleUrls: ['./timeline-event-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineEventFilterComponent implements OnChanges {

  @Input()
  public eventTypes;

  @Output()
  public filterChange = new EventEmitter();

  public formConfig: DynamicFormItem[];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.eventTypes) {
      this.createFilterForm();
    }
  }

  private createFilterForm() {
    this.formConfig = undefined;
    if (!this.eventTypes || this.eventTypes.length < 1) {
      return;
    }
    this.formConfig = [
      new DynamicFormItem(
        '',
        FORM_KEY_EVENT_TYPE_SELECTION,
        ITEMS_TYPES.WIDGET
      )
        .setPlaceholder('Filter')
        .setComponentToLoad('MultiSelectComponent')
        .setOptions(this.eventTypes)
        .setAttributes({
          '[forceFormMode]': true
        })
    ];
  }

  public updateEventTypeSelection($event) {
    this.filterChange.emit($event.form[FORM_KEY_EVENT_TYPE_SELECTION]);
  }
}
